import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  giftProductLabel: {
    id: 'checkout.cartPage.gift',
    defaultMessage: 'Gift',
    description: 'Additional label for gift product',
  },
  tryItFirstProductLabel: {
    id: 'checkout.cartPage.tryItFirst',
    defaultMessage: 'Free Sample',
    description: 'Additional label for try it first product',
  },
  engravingLabel: {
    id: 'checkout.cartPage.engravingLabel',
    defaultMessage: 'Product engraving',
    description: 'Engraving label on cart page',
  },
  engravingDeliveryTimeDelay: {
    id: 'checkout.cartPage.engravingDeliveryTimeDelay',
    defaultMessage: 'The delivery time may be delayed by one day!',
    description: 'Additional info that delivery engraving product can be delayed',
  },
  usedProductContentAmount: {
    id: 'checkout.cartPage.usedProductContentAmount',
    defaultMessage: 'Contents of the product: {amount} %.',
    description: 'Additional label for used product content amount',
  },
  freeProduct: {
    id: 'checkout.cartPage.freeProduct',
    defaultMessage: 'free',
    description: 'When product has price 0 write free',
  },
  removeProduct: {
    id: 'checkout.cartPage.removeProduct',
    defaultMessage: 'This product is currently sold out. Please remove it.',
    description: 'Info message of sold out product on cart page',
  },
  changeProductQuantity: {
    id: 'checkout.cartPage.changeProductQuantity',
    defaultMessage: 'Last {quantity} pcs in stock. Please, change the amount.',
    description: 'Info message if product quantity exceeded maximum quantity in stock',
  },
  addedByCouponGiftLabel: {
    id: 'checkout.cartPage.giftAddedByCoupon',
    defaultMessage: 'Added by coupon: {couponCode}',
    description: 'Label for gift which was added by coupon.',
  },
  inSaleLabel: {
    id: 'checkout.cartPage.inSaleLabel',
    defaultMessage: 'Sale',
    description: 'Label for product which is in sale.',
  },
  inClearanceLabel: {
    id: 'checkout.cartPage.inClearanceLabel',
    defaultMessage: 'Clearance',
    description: 'Label for product which is in clearance.',
  },
  inSaleInfoMarkText: {
    id: 'checkout.cartPage.inSaleInfoMarkText',
    defaultMessage:
      'The lowest price this product has been offered at in the last 30 days before the start of this offer/sale.',
    description: 'Text for info mark popup when product is in sale',
  },
  inSaleInfoMarkTextLink: {
    id: 'checkout.cartPage.inSaleInfoMarkTextLink',
    defaultMessage: 'More information',
    description: 'Text link for info mark popup when product is in sale',
  },
  inSaleInfoMarkLink: {
    id: 'checkout.cartPage.inSaleInfoMarkLink',
    defaultMessage: '#',
    description: 'Link for info mark popup when product is in sale',
  },
  airDeliveryForbidden: {
    id: 'checkout.cartPage.airDeliveryForbidden',
    defaultMessage: 'Letecká doprava není povolena',
    description: 'Information message about goods are forbidden for air delivery.',
  },
  medicinalProductLabel: {
    id: 'checkout.cartPage.medicinalProductLabel',
    defaultMessage:
      'Léčiva a zdravotnické prostředky <b> nedoručujeme </b> z důvodu ohrožení jejich kvality do <b> výdejních boxů. </b> Zvolte prosím jinou dopravu.',
    description:
      'Information message about goods that are not delivered to pups due to medicinal product restrictions.',
  },
  voucherUnderProductLabel: {
    id: 'checkout.cartPage.product.withCode',
    defaultMessage: 'with code',
    description: 'Message for voucher under product',
  },
});
